import * as MetaReducers from './wizard.metareducer';
import * as Reducers from './wizard.reducer';

export const WizardReducers = {
  Reducers,
  MetaReducers,
};
